import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function FloatingButtons() {

  /*const phoneNumber = "919836904698";*/
  const callNumber = "9836904698";

  return (
    <>
      {/* WhatsApp */}
      <a
        href="https://wa.me/919876543210?text=Hi%2C%20I%20am%20interested%20in%20your%20services%2C%20can%20you%20share%20more%20details%20%3F"
        target="_blank"
        rel="noopener noreferrer"
        className="float-btn whatsapp-btn"
      >
        <i className="bi bi-whatsapp"></i>
      </a>

      {/* Call */}
      <a
        href={`tel:${callNumber}`}
        className="float-btn call-btn"
      >
        <i className="bi bi-telephone-fill"></i>
      </a>

      {/* STYLES INSIDE COMPONENT */}
      <style>{`

        .float-btn{
          position:fixed;
          right:18px;
          width:58px;
          height:58px;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:26px;
          color:white;
          z-index:9999;
          box-shadow:0 6px 20px rgba(0,0,0,0.3);
          transition:0.3s;
          text-decoration:none;
        }

        /* whatsapp */
        .whatsapp-btn{
          bottom:95px;
          background:#25D366;
        }
        .whatsapp-btn:hover{
          transform:scale(1.12);
          background:#1ebe5d;
        }

        /* call */
        .call-btn{
          bottom:25px;
          background:#ffc107;
          color:black;
        }
        .call-btn:hover{
          transform:scale(1.12);
          background:#ffb300;
        }

        /* mobile */
        @media(max-width:768px){
          .float-btn{
            width:52px;
            height:52px;
            font-size:22px;
          }
          .whatsapp-btn{ bottom:85px; }
          .call-btn{ bottom:18px; }
        }

      `}</style>
    </>
  );
}
